export default __webpack_public_path__ + "static/media/location.6947c0c4.svg";